import React, { useState, useEffect } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";

const IdsInput = ({ value, onChange, onValidChange, labelText = "ID" }) => {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");

  // 处理输入变更
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    onChange(newValue);

    // 验证新值
    validateIds(newValue);
  };

  // 验证ID列表
  const validateIds = (input) => {
    // 空输入视为有效
    if (!input.trim()) {
      setError("");
      return true;
    }

    // 分割并验证每个ID
    const ids = input
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    const invalidIds = ids.filter((id) => !/^\d+$/.test(id));

    const isValid = invalidIds.length === 0;
    setError(isValid ? "" : `无效ID格式: ${invalidIds.join(", ")}`);
    return isValid;
  };

  // 当验证状态变化时通知父组件
  useEffect(() => {
    if (onValidChange) {
      onValidChange(!error);
    }
  }, [error, onValidChange]);

  // 复制ID到剪贴板
  const copyToClipboard = () => {
    navigator.clipboard.writeText(value).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      },
      (err) => console.error("复制失败:", err),
    );
  };

  return (
    <div className="bg-blue-50 p-4 rounded-lg border mb-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-medium text-gray-700">查询条件</h3>
      </div>

      <div className="flex items-center space-x-2 mb-2">
        <label className="text-gray-700 font-medium">{labelText}:</label>
        <div className="flex-grow relative">
          <input
            type="text"
            value={value}
            onChange={handleInputChange}
            placeholder="输入PO ID，多个ID用英文逗号分隔"
            className={`border rounded p-2 w-full ${
              error ? "border-red-500" : ""
            }`}
          />
          {value && (
            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 bg-gray-100 hover:bg-gray-200 rounded transition-colors"
              onClick={copyToClipboard}
              title={`复制${labelText}`}
            >
              {copied ? (
                <FiCheck className="text-green-600 h-4 w-4" />
              ) : (
                <FiCopy className="text-gray-600 h-4 w-4" />
              )}
            </button>
          )}
        </div>
      </div>

      {error && <div className="text-xs text-red-500 mt-1">{error}</div>}
    </div>
  );
};

export default IdsInput;
